var _rect, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkr(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 28,
    viewBox: "0 0 29 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.708008,
    width: 28,
    height: 28,
    rx: 14,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21912_233578)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6621 5.54749H12.9126L15.0025 9.34651L14.3309 10.627L11.6621 5.54749Z",
    fill: "#028C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7441 11.3939H16.0999L19.1095 5.54749H17.641L14.7441 11.3939Z",
    fill: "#F07401"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.85536 8.15117H6.808V9.25128H9.12851C10.1159 9.20868 10.9052 8.39675 10.9052 7.39938C10.9052 6.40201 10.1159 5.59259 9.12851 5.5525V5.54749H6.55991C5.53748 5.54749 4.70801 6.37696 4.70801 7.39938V9.92037C4.70801 10.1158 4.71302 10.4592 5.06135 10.8626C5.40717 11.2661 5.81063 11.3914 6.33938 11.3914H9.55201V10.2336H6.11134C5.77554 10.2336 5.80812 9.62216 5.80812 9.62216V7.73769C5.80812 7.73769 5.78807 7.12623 5.89332 6.93578C6.03115 6.76287 6.24165 6.6501 6.47972 6.6501H8.85536C9.26884 6.6501 9.60714 6.98841 9.60714 7.40189C9.60714 7.81537 9.26884 8.15367 8.85536 8.15367V8.15117Z",
    fill: "#028C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.80311 13.722V20.7186C5.80311 20.9366 5.63772 21.3075 7.07112 21.3075V22.3976H6.1364C5.62519 22.3976 5.29189 22.1795 5.13402 22.0517C4.97614 21.9239 4.70801 21.6332 4.70801 21.2649V14.7895C4.70801 14.5539 4.75311 14.1856 5.15407 13.8974C5.55502 13.6092 5.80311 13.7195 5.80311 13.7195V13.722Z",
    fill: "#028C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.89305 16.8468H8.77539V22.4H9.89305V16.8468Z",
    fill: "#028C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33419 15.9872C9.7051 15.9872 10.0058 15.6865 10.0058 15.3156C10.0058 14.9447 9.7051 14.644 9.33419 14.644C8.96328 14.644 8.6626 14.9447 8.6626 15.3156C8.6626 15.6865 8.96328 15.9872 9.33419 15.9872Z",
    fill: "#028C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4858 18.1725C17.4858 18.1725 17.4758 17.734 17.0698 17.348C16.6638 16.9621 16.3681 16.9396 16.3681 16.9396H16.1977H12.7771C12.7771 16.9396 12.4914 16.9396 12.0579 17.3831C11.6244 17.8267 11.662 18.363 11.662 18.363V22.3975H12.7771V18.3229C12.7771 18.19 12.8673 18.0798 12.9876 18.0497H16.1576C16.2779 18.0798 16.3681 18.19 16.3681 18.3229V22.3975H17.4858V18.2001C17.4858 18.2001 17.4833 18.18 17.4833 18.17H17.4858V18.1725Z",
    fill: "#028C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7815 13.8999C19.3806 14.1881 19.3354 14.5564 19.3354 14.792V22.4552H20.4306V13.7245C20.4306 13.7245 20.1825 13.6142 19.7815 13.9024V13.8999Z",
    fill: "#028C86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2621 19.9993L22.207 19.9467C22.1343 19.8715 22.0141 19.7286 22.0065 19.5983C21.9965 19.4129 22.3473 19.0195 22.3473 19.0195L24.5626 16.8468H23.1142C23.1142 16.8468 21.7509 18.1298 21.162 18.8716C21.162 18.8716 20.8237 19.235 20.8237 19.5407C20.8237 19.8464 21.4552 20.5556 21.4552 20.5556C22.0993 21.3074 23.257 22.4 23.257 22.4H24.7055L22.2596 20.0018L22.2621 19.9993Z",
    fill: "#028C86"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21912_233578"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 16.9051,
    fill: "white",
    transform: "translate(4.70801 5.54749)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkr);
export default __webpack_public_path__ + "static/media/skr.b77aca83a55667e747b47b84b60a5314.svg";
export { ForwardRef as ReactComponent };